import React, { useState, useEffect } from "react";
import { Card, CardContent } from "./ui/card";

const BenefitsSlider = ({ benefits }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 664) {
        setItemsPerPage(1);
      } else if (window.innerWidth < 1024) {
        setItemsPerPage(2);
      } else {
        setItemsPerPage(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const getVisibleBenefits = () => {
    const result = [];
    for (let i = 0; i < itemsPerPage; i++) {
      const index = (currentIndex + i) % benefits.length;
      result.push(benefits[index]);
    }
    return result;
  };

  return (
    <div className="relative">
      {itemsPerPage === 1 ? (
        // Mobile: Slider mode
        <>
          <div className="grid gap-6 grid-cols-1">
            {getVisibleBenefits().map((benefit, index) => (
              <Card
                key={`${index}-${currentIndex}`}
                className="border-l-4 border-brand-purple hover:shadow-lg transition-shadow duration-300"
              >
                <CardContent className="pt-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{benefit.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          {benefits.length > itemsPerPage && (
            <div className="flex justify-center gap-3 mt-8">
              {Array.from({ length: benefits.length }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentIndex
                      ? "bg-brand-purple w-8"
                      : "bg-gray-300 hover:bg-brand-purple/50"
                  }`}
                  aria-label={`Go to benefit ${index + 1}`}
                />
              ))}
            </div>
          )}
        </>
      ) : (
        // Desktop: Static grid mode
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <Card
              key={index}
              className="border-l-4 border-brand-purple hover:shadow-lg transition-shadow duration-300"
            >
              <CardContent className="pt-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default BenefitsSlider;
